export const URL_Scheduling = (`${process.env.REACT_APP_HOST}/scheduling`)
